import { useMemo } from 'react';

import { createApiGqlClient } from '@ui-furniture/clients/create-api-gql-client';

type ApiGqlClientConfig = Parameters<typeof createApiGqlClient>[0];

export const useApiGqlClient = (config: ApiGqlClientConfig, deps = []) =>
  useMemo(() => createApiGqlClient(config), deps);
